<template>
  <div class="request-user-info">

    <div class="input-group">
      <label class="header">Validate user message as</label>
      <select name="categories" v-model="requestUserInfo.requestValue" class="basic-select ">
        <option value="phone">Phone</option>
        <option value="email">Email</option>
      </select>
    </div>

    <div class="separator"></div>

    <div class="input-group">
      <div class="inline-switch">
        <BasicSwitch v-model="requestUserInfo.skipIfAlreadyProvided" />
      </div>
      <label class="header inline">Skip if already provided</label>
    </div>

    <div class="separator"></div>

    <div class="input-group">
      <label class="header">Valid message</label>
      <textarea v-model.trim="requestUserInfo.validMessage" rows="2" class="basic-textarea" placeholder="This text will be sent to user on value validation success. Can be empty." />
    </div>

    <div class="input-group">
      <label class="header">Invalid Message</label>
      <textarea v-model.trim="requestUserInfo.invalidMessage" rows="2" class="basic-textarea" placeholder="This text will be sent to user on value validation failure. Can be empty." />
    </div>

    <transition name="fade" mode="out-in">

      <div v-show="requestUserInfo.requestValue == 'phone'">
        <div class="separator"></div>

        <div class="input-group">
          <label class="header">Request Phone Number Button</label>
          <BasicInput v-model.trim="requestUserInfo.telegramRequestPhoneButtonText" class="wide" placeholder="Button Text" />
        </div>
      </div>  

    </transition>
  
    <div class="separator"></div>

    <BotActionButton class="gray shadow no-margins" @click="removeRequestUserInfo">Remove</BotActionButton>

  </div>  
</template>

<script>
import BasicSwitch from '@/components/buttons/BasicSwitch';
import BotActionButton from '@/components/buttons/BotActionButton';
import BasicInput from '@/components/inputs/BasicInput';

export default {
  data: () => {
    return {
      menuOpen: false,
      actionsContainerOpen: false,
      replyKeyboardOpen: false
    }
  },
  props: ['requestUserInfo'],
  mounted() {},
  methods: {
    removeRequestUserInfo() {
      this.$emit("messageRemoveRUI");
    }
  },
  components: {BasicSwitch, BotActionButton, BasicInput}
}
</script>

<style lang="scss">
.request-user-info {
  display: flex;
  flex-direction: column;

  .input-group {
    margin: 6px 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }

    label.header {
      margin-bottom: 6px;
      display: block;

      &.inline {
        margin-bottom: 0;
        display: inline-block;
      }
    }

    .inline-switch {
      display: inline-block;
      margin-right: 12px;
    }
    .basic-select {
      width: 100%;
    }

  }

  .separator {
    display: block;
    width: 100%;
    height: 1px;
    background-color: #555555;
    margin: 12px 0;
  }
}
</style>
